/** Safe fallback when CMS does not provide a localized buy-vignette URL. */
export const BUY_VIGNETTE_FALLBACK_PATH = '/en/buy-vignette/';

/**
 * @param {string|null|undefined} primary CMS / prop URL
 * @returns {string}
 */
export function resolveBuyVignetteHref(primary) {
    const trimmed = typeof primary === 'string' ? primary.trim() : '';
    if (trimmed) {
        return trimmed;
    }

    if (typeof window === 'undefined') {
        return BUY_VIGNETTE_FALLBACK_PATH;
    }

    try {
        return new URL(BUY_VIGNETTE_FALLBACK_PATH, window.location.origin).href;
    } catch {
        return BUY_VIGNETTE_FALLBACK_PATH;
    }
}
